import { useState } from "react";
import "./Report.css";
import { FaSearch } from "react-icons/fa";
import { IoReload } from "react-icons/io5";
import DateFilter from "../../../components/common/DateFilter";

function ReportHeader({
  searchType,
  setSearchText,
  searchText,
  hitFetchApi,
  setParentStartDate,
  setParentEndDate,
}) {
  const handleChange = (e, setSearchText) => {
    setSearchText(e.target.value);
  };
  const reloadfunction = () => {
    window.location.reload();
  };

  const handleDateChange = (start, end) => {
    setParentStartDate(start);
    setParentEndDate(end);
  };
  return (
    <div>
      <div className="manage-header-report">
        <h2 className="area-top-title-report">Pay Out Report</h2>
      </div>
      <DateFilter onDateChange={handleDateChange} />
      <div className="search-divs-report">
        <div className="search-report">
          <input
            type="text"
            className="search-input-report"
            placeholder="Search"
            onChange={(e) => handleChange(e, setSearchText)}
          />
          <FaSearch className="search-icon-report" />
        </div>

        <button
          className="go-btn"
          onClick={() => hitFetchApi(searchType, searchText)}
        >
          Go
        </button>
        <button className="reload-btn" onClick={() => reloadfunction()}>
          <IoReload />
        </button>
      </div>
    </div>
  );
}

export default ReportHeader;
